import Layout from "../include/layout";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { myroutes } from "../../routes/webroute";
import { checkAuthenticate } from "../app/providers/authSlice";
import ClassesService from "../classe/ClassesService";
import $ from "jquery";
import TypesinscriptionsService from "../typesinscriptions/TypesinscriptionsService";
import Filarial from "../include/filarial";
import Joi from "joi-browser";
import MatieresService from "../matieres/MatieresService";
import ClassesoptionsService from "../classesoptions/ClassesoptionsService";
import TypesevaluationsService from "../typesevaluations/TypesevaluationsService";
import { Dropdown } from "primereact/dropdown";
import NotesService from "./NotesService";
import AnneesacademiquesService from "../anneesacademiques/AnneesacademiquesService";
import PeriodicitesScolairesService from "../periodicitesscolaires/PeriodicitesScolairesService";
import ApprenantsService from "../apprenants/ApprenantsService";

export default function NotesCreate() {
  const token = useSelector((state) => state.auth.token);
  const activeLink = "NOTES ET MOYENNES";
  const [errors, setErrors] = useState({});

  //Elément du formulaire d'ajout de grille tarifaire
  const [matieres, setMatieres] = useState([]);
  const [matiereId, setMatiereId] = useState("");
  const [classesoptions, setClassesoptions] = useState([]);
  const [selectedOptionMatiere, setSelectedOptionMatiere] = useState(null);
  const [coefficientMatiere, setCoefficientMatiere] = useState('');
  const [anneesacademiques, setAnneesacademiques] = useState([]);
  const [anneeacademiqueId, setAnneeacademiqueId] = useState("");
  const [periodicitesscolaires, setPeriodicitesscolaires] = useState([]);
  const [periodicitescolaireId, setPeriodicitescolaireId] = useState("");
  const [classeoptionId, setClasseoptionId] = useState("");
  const [selectedOptionClasseoption, setSelectedOptionClasseoption] =
    useState(null);
    const [apprenantId, setApprenantId] = useState("");
    const [noteinterrogation1DetailNote, setNoteinterrogation1DetailNote] = useState("");
    const [noteinterrogation2DetailNote, setNoteinterrogation2DetailNote] = useState("");
    const [noteinterrogation3DetailNote, setNoteinterrogation3DetailNote] = useState("");
    const [noteinterrogation4DetailNote, setNoteinterrogation4DetailNote] = useState("");
    const [noteinterrogation5DetailNote, setNoteinterrogation5DetailNote] = useState("");
    const [notedevoir1DetailNote, setNotedevoir1DetailNote] = useState("");
    const [notedevoir2DetailNote, setNotedevoir2DetailNote] = useState("");
    const [appreciationDetailNote, setAppreciationDetailNote] = useState("");
    const [moyenneinterrogationDetailNote, setMoyenneinterrogationDetailNote] = useState("");
    const [moyennegeneraleDetailNote, setMoyennegeneraleDetailNote] = useState("");
    const [moyennecoefficieeDetailNote, setMoyennecoefficieeDetailNote] = useState("");
  const [selectedClasseId, setSelectedClasseId] = useState('');
  const [apprenants, setApprenants] = useState([]);
  const [apprenantsNotes, setApprenantsNotes] = useState([]);
  const [notes, setNotes] = useState([]);





  const navigate = useNavigate();

  //check if user is authenticated
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticate);

  const [validationError, setValidationError] = useState({});

  //get liste matieres
  const fetchMatieres = async () => {
    await MatieresService.index(token)
      .then((response) => {
        setMatieres(response.data.data.matieres);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const datamatieres = matieres.map((item) => ({
    value: item.id,
    label: item.libelleMatiere,
    coefficient: item.coefficientMatiere,
 }));

  const handleChangeMatiere = (e) => {
    const selectedOptionMatiere = e.value;
    setSelectedOptionMatiere(selectedOptionMatiere);
  
    // Trouver le coefficient correspondant à la matière sélectionnée
  const selectedMatiere = datamatieres.find(item => item.value === selectedOptionMatiere);
  const selectedCoefficient = selectedMatiere ? selectedMatiere.coefficient : ''; // Récupération du coefficient
  //console.log("Selected Matiere:", selectedOptionMatiere);
  //console.log("Selected Coefficient:", selectedCoefficient);
  setCoefficientMatiere(selectedCoefficient);
  };
  

  //get liste classeoption
  const fetchClassesoptions = async () => {
    await ClassesoptionsService.index(token)
      .then((response) => {
        setClassesoptions(response.data.data.classesoptions);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const dataclassesoptions = classesoptions.map((item) => ({
    value: item.id,
    label: item.libelleClasseOption,
  }));

  //get liste annes academiques
  const fetchAnneesacademiques = async () => {
    await AnneesacademiquesService.index(token)
      .then((response) => {
        setAnneesacademiques(response.data.data.anneesacademiques);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //get liste periodicites scolaires
  const fetchPeriodicitesscolaires = async () => {
    await PeriodicitesScolairesService.index(token)
      .then((response) => {
        setPeriodicitesscolaires(response.data.data.periodicitesscolaires);
      })
      .catch((error) => {
        console.log(error);
      });
  };

       //get liste apprenants
    const fetchApprenants = async () => {
      await ApprenantsService.index(token).then((res) => {
          //console.log(res.data.data.apprenants)
          setApprenants(res.data.data.apprenants)
      }).catch(error => {
          console.log(error)
      })
      //initialize datatable
      $(document).ready(function () {
          $('.data-table').DataTable();
      });
  }
    

    // Fonction pour récupérer les apprenants en fonction de la classe sélectionnée
   const fetchApprenantsByClasse = async (classeoptionId) => {
      try {
        const response = await ApprenantsService.getApprenantsByClasseoption(classeoptionId, token);
        console.log("ID sélectionné : ", classeoptionId); 
        // alert("ID sélectionné : " + classeoptionId);
     console.log(response.data.data);
        setApprenants(response.data.data);
      } catch (error) {
        console.error(error);
      }
    };

   

 /* const handleSubmitData = async (e) => {
    e.preventDefault();
    //alert("ok")
    const formData = new FormData();
    formData.append("matiereId", selectedOptionMatiere);
    formData.append("classeoptionId", selectedOptionClasseoption);
    formData.append("anneeacademiqueId", anneeacademiqueId);
    formData.append("periodicitescolaireId", periodicitescolaireId);

    apprenants.forEach((apprenant, index) => {
      formData.append(`notes[${index}].apprenantId`, apprenant.id);
    });

    // Ajout des données de chaque apprenant dans formData
    notes.forEach((note,index) => {
      formData.append(`notes[${index}].noteinterrogation1DetailNote`, note.noteinterrogation1DetailNote);
      formData.append(`notes[${index}].noteinterrogation2DetailNote`, note.noteinterrogation2DetailNote);
      formData.append(`notes[${index}].noteinterrogation3DetailNote`, note.noteinterrogation3DetailNote);
      formData.append(`notes[${index}].noteinterrogation4DetailNote`, note.noteinterrogation4DetailNote);
      formData.append(`notes[${index}].noteinterrogation5DetailNote`, note.noteinterrogation5DetailNote);
      formData.append(`notes[${index}].notedevoir1DetailNote`, note.notedevoir1DetailNote);
      formData.append(`notes[${index}].notedevoir2DetailNote`, note.notedevoir2DetailNote);
    });

    // Affichage des données envoyées dans la console
    console.log('Avant la boucle for');
    for (let pair of formData.entries()) {
      console.log(pair[0] + ': ' + pair[1]);
    }
    console.log('Après la boucle for');
  
    try {
      const response = await NotesService.store(formData, token);
  
      if (response.data.status === 200) {
        // Redirection vers index
        navigate(myroutes.notes_index);
        Swal.fire({
          icon: "success",
          text: response.data.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          text: response.data.message,
          showConfirmButton: true,
          timer: 3000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: error.message,
      });
    }
  };*/

  /*  const dataToSend = {
        matiereId: 9,
        classeoptionId: 21,
        anneeacademiqueId: 4,
        periodicitescolaireId: 1,
        apprenantId: 6,
        noteinterrogation1DetailNote: 15,
        noteinterrogation2DetailNote: 14,
        noteinterrogation3DetailNote: 16,
        noteinterrogation4DetailNote: 13,
        noteinterrogation5DetailNote: 17,
        notedevoir1DetailNote: 12,
        notedevoir2DetailNote: 11,
            };*/
          /*  const notesData = apprenants.map((apprenant, index) => {
              const currentNote = apprenantsNotes[index];
          
              return {
                apprenantId: apprenant.id,
                noteinterrogation1DetailNote: (currentNote && currentNote.noteinterrogation1DetailNote) || 0,
                noteinterrogation2DetailNote: (currentNote && currentNote.noteinterrogation2DetailNote) || 0,
                noteinterrogation3DetailNote: (currentNote && currentNote.noteinterrogation3DetailNote) || 0,
                noteinterrogation4DetailNote: (currentNote && currentNote.noteinterrogation4DetailNote) || 0,
                noteinterrogation5DetailNote: (currentNote && currentNote.noteinterrogation5DetailNote) || 0,
                notedevoir1DetailNote: (currentNote && currentNote.notedevoir1DetailNote) || 0,
                notedevoir2DetailNote: (currentNote && currentNote.notedevoir2DetailNote) || 0,
              };
            });*/

              // Fonction pour mettre à jour les notes d'un apprenant
  const handleNoteChange = (index, fieldName, value) => {
    const updatedNotes = [...notes];
    updatedNotes[index] = {
      ...updatedNotes[index],
      [fieldName]: value,
    };
    setNotes(updatedNotes);
  };
  

  const handleSubmitData = async (e) => {
    e.preventDefault();
  
    try {
      const notesToSend = apprenants.map((apprenant, index) => ({
        matiereId: selectedOptionMatiere,
        classeoptionId: selectedOptionClasseoption,
        anneeacademiqueId: anneeacademiqueId,
        periodicitescolaireId: periodicitescolaireId,
        apprenantId: apprenant.id,
        noteinterrogation1DetailNote: notes[index]?.noteinterrogation1DetailNote || 0,
        noteinterrogation2DetailNote: notes[index]?.noteinterrogation2DetailNote || 0,
        noteinterrogation3DetailNote: notes[index]?.noteinterrogation3DetailNote || 0,
        noteinterrogation4DetailNote: notes[index]?.noteinterrogation4DetailNote || 0,
        noteinterrogation5DetailNote: notes[index]?.noteinterrogation5DetailNote || 0,
        notedevoir1DetailNote: notes[index]?.notedevoir1DetailNote || 0,
        notedevoir2DetailNote: notes[index]?.notedevoir2DetailNote || 0,
      }));
  
      const response = await Promise.all(
        notesToSend.map((data) => NotesService.store(data, token))
      );
  
      const success = response.every((res) => res.data.status === 200);
  
      if (success) {
        navigate(myroutes.notes_index);
        Swal.fire({
          icon: "success",
          text: "Toutes les données ont été enregistrées avec succès.",
        });
      } else {
        Swal.fire({
          icon: "error",
          text: "Il y a eu une erreur lors de l'enregistrement des données.",
          showConfirmButton: true,
          timer: 3000,
        });
      }
    } catch (error) {
      console.log(error);
      alert(error);
      Swal.fire({
        icon: "error",
        text: error.message,
      });
    }
  };
  
    
  


  useEffect(() => {
    // Vérifier si l'utilisateur est connecté lors du chargement de l'application
    dispatch(checkAuthenticate());
    if (!isAuthenticated) {
      //console.log(isAuthenticated)
      //Redirection sur le dashboard
      navigate(myroutes.login);
      fetchApprenantsByClasse();
    }
    fetchClassesoptions();
    fetchAnneesacademiques();
    fetchPeriodicitesscolaires();
    fetchMatieres();
    fetchApprenants();
  }, [dispatch]);



  return (
    <Layout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Filarial activeLink={activeLink} />

        <div className="row mb-4 mt-3">
          {/* Bootstrap Validation */}
          <div className="col-md">
            <div className="card shadow-lg">
              <div className="col-md-12 text-center">
                <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2">
                  Enregistrement des notes
                </h5>
              </div>
              <div className="card-body">
                <Row>
                  {Object.keys(validationError).length > 0 && (
                    <div className="row">
                      <div className="col-12">
                        <div className="alert alert-danger">
                          <ul className="mb-0">{<li>{validationError}</li>}</ul>
                        </div>
                      </div>
                    </div>
                  )}
                </Row>
                <Form
                  className="needs-validation"
                  noValidate
                  onSubmit={handleSubmitData}
                >
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <Form.Label
                        className="form-label fw-bold"
                        htmlFor="anneeacademiqueId"
                      >
                        Annee academique <i className="text-danger">*</i>
                      </Form.Label>
                      <Form.Select
                        className=""
                        id="anneeacademiqueId"
                        value={anneeacademiqueId}
                        required
                        onChange={(e) => {
                          setAnneeacademiqueId(e.target.value);
                        }}
                      >
                        <option value="" selected>
                          -- Sélectionnez --
                        </option>
                        {anneesacademiques.length > 0 &&
                          anneesacademiques.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.anneedebutAnneeacademique +
                                " - " +
                                item.anneefinAnneeacademique}
                            </option>
                          ))}
                      </Form.Select>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Label
                        className="form-label fw-bold"
                        htmlFor="selectedOptionClasseoption"
                      >
                        Classe option <i className="text-danger">*</i>
                      </Form.Label>
                      <Dropdown
                        required
                        value={selectedOptionClasseoption}
                        onChange={(e) => 
                          {
                          setSelectedOptionClasseoption(e.value); 
                          fetchApprenantsByClasse(e.value);
                          }}
                        options={dataclassesoptions}
                        optionLabel="label"
                        placeholder=" Sélectionner une classe"
                        filter
                        className="w-full md:w-25rem my-custom-class"
                        style={{ width: "100%", height: "40px" }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <Form.Label
                        className="form-label fw-bold"
                        htmlFor="periodicitesscolaireId"
                      >
                        Periodicites Scolaires <i className="text-danger">*</i>
                      </Form.Label>
                      <Form.Select
                        className=""
                        id="periodicitesscolaireId"
                        value={periodicitescolaireId}
                        required
                        onChange={(e) => {
                          setPeriodicitescolaireId(e.target.value);
                        }}
                      >
                        <option value="" selected>
                          -- Sélectionnez --
                        </option>
                        {periodicitesscolaires.length > 0 &&
                          periodicitesscolaires.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.libellePeriodiciteScolaire}
                            </option>
                          ))}
                      </Form.Select>
                    </div>
                    <div className="col-md-5 mb-3">
                      <Form.Label
                        className="form-label fw-bold"
                        htmlFor="selectedOptionMatiere"
                      >
                        Matiere <i className="text-danger">*</i>
                      </Form.Label>
                      <Dropdown
                        required
                        value={selectedOptionMatiere}
                        onChange={handleChangeMatiere}
                        options={datamatieres}
                        optionLabel="label"
                        placeholder=" Sélectionner une matiere "
                        filter
                        className="w-full md:w-25rem my-custom-class"
                        style={{ width: "100%", height: "40px" }}
                      />
                    </div>
                    <div className="col-md-1 mb-3">
                      <Form.Label
                        className="form-label fw-bold"
                        htmlFor="coefficientMatiere"
                      >
                        Coef. 
                      </Form.Label>
                      <Form.Control
                        className="form-control fw-bold"
                        id="bs-validation-coefficicientMatiere"
                        type="text"
                        required={true}
                        name="coefficientMatiere"
                        value={coefficientMatiere}
                        readOnly
                        style={{ backgroundColor:'#28a745', color: 'white' }}
                        />

                    </div>
                  </div>

                {/* /start enregistrement des notes */}
                <div className="row mt-4">

                <div className="col-md">
              <table className="tablenotes">
                <thead className="theme-bg-blue-white theme-color-blue px-3 py-2">
                  <tr>
                  <th>NumMat</th>
                      <th>Nom&Prenoms</th>
                      <th>Interro.1</th>
                      <th>Interro.2</th>
                      <th>Interro.3</th>
                      <th>Interro.4</th>
                      <th>Interro.5</th>
                      <th>Devoir.1</th>
                      <th>Devoir.2</th>
                      </tr>
                </thead>
                {apprenants && apprenants.length === 0 && (
                  <tbody>
                    <tr>
                      <td colSpan="12">
                        <div className="alert alert-info m-4 mx-auto text-center" style={{ width: "400px" }} role="alert">
                          Aucune donnée n'a été enregistrée pour cette classe
                        </div>
                      </td>
                    </tr>
                  </tbody>
                )}
                {apprenants && apprenants.length > 0 && (
                    <tbody>
                    {apprenants && apprenants.map((apprenant, index) => (
                    <tr key={apprenant.id}>
                      <td>{apprenant.matriculeApprenant}</td>
                      <td>{apprenant.inscriptions.personnes.nomPersonne + ' ' + apprenant.inscriptions.personnes.prenomsPersonne}</td>
  
                      <td> <input type="number" className="form-control" onChange={(e) => handleNoteChange(index, 'noteinterrogation1DetailNote', parseFloat(e.target.value))} value={notes[index]?.noteinterrogation1DetailNote || ''} name="noteinterrogation1DetailNote"/>
                      </td>                    
                      <td> <input type="number" className="form-control" onChange={(e) => handleNoteChange(index, 'noteinterrogation2DetailNote', parseFloat(e.target.value))} value={notes[index]?.noteinterrogation2DetailNote || ''} name="noteinterrogation2DetailNote"/>
                      </td> 
                      <td> <input type="number" className="form-control" onChange={(e) => handleNoteChange(index, 'noteinterrogation3DetailNote', parseFloat(e.target.value))} value={notes[index]?.noteinterrogation3DetailNote || ''} name="noteinterrogation3DetailNote"/>
                      </td> 
                      <td> <input type="number" className="form-control" onChange={(e) => handleNoteChange(index, 'noteinterrogation4DetailNote', parseFloat(e.target.value))} value={notes[index]?.noteinterrogation4DetailNote || ''} name="noteinterrogation4DetailNote"/>
                      </td> 
                      <td> <input type="number" className="form-control" onChange={(e) => handleNoteChange(index, 'noteinterrogation5DetailNote', parseFloat(e.target.value))} value={notes[index]?.noteinterrogation5DetailNote || ''} name="noteinterrogation5DetailNote"/>
                      </td> 
                      <td>
                      <input type="number" className="form-control"  onChange={(e) => handleNoteChange(index, 'notedevoir1DetailNote', parseFloat(e.target.value))} value={notes[index]?.notedevoir1DetailNote || ''} name="notedevoir1DetailNote"/>
                        </td>
                      <td>
                      <input type="number" className="form-control"  onChange={(e) => handleNoteChange(index, 'notedevoir2DetailNote', parseFloat(e.target.value))} value={notes[index]?.notedevoir2DetailNote || ''} name="notedevoir2DetailNote"/>
                        </td>
                    </tr>
                  ))}
                    </tbody>
                )}
              </table>
            </div>
                </div>
                  {/* /end enregistrement des notes */}

                  <div className="row pt-2">
                    <div className="col-12">
                      <button type="submit" className="btn btn-primary">
                        Enregistrer
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
          {/* /Bootstrap Validation */}
        </div>
      </div>
    </Layout>
  );
}
